export default __webpack_public_path__ + "static/media/equal-footer-banner-right.55ee4221.png";